import { ReactNode } from 'react';

import HsBackdrop from './HsBackdrop';
import HsCenterPage from './HsCenterPage';

import './hs.scss';

interface Props {
  /** 크게 보여 줄 상태 번호(404·403) 또는 아이콘 */
  code?: string;
  icon?: string;
  title: ReactNode;
  description?: ReactNode;
  /** 버튼들(홈으로 등) */
  children?: ReactNode;
}

/** 404·403·화면 오류처럼 "여기서는 할 게 없다"를 알려 주는 단독 화면. 모든 서비스가 같이 쓴다 */
export default function HsStatusPage({ code, icon, title, description, children }: Props) {
  return (
    <HsCenterPage
      className="HsStatusPage"
      backdrop={<HsBackdrop variant="net" subtle />}
      mark={code ? <span className="hs-status-code">{code}</span> : <i className={`hs-status-icon ${icon}`} />}
      title={title}
      description={description}
    >
      {children && <div className="hs-status-actions">{children}</div>}
    </HsCenterPage>
  );
}
